module.exports = __webpack_public_path__ + "static/media/r5s3.d54b1ee3.jpg";